var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgIconLogout = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-62)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M73,15h2v5a2,2,0,0,1-2,2H66a2,2,0,0,1-2-2V4a2,2,0,0,1,2-2h7a2,2,0,0,1,2,2V9H73V4H66V20h7Zm10.923-2.618a1,1,0,0,0-.217-1.09l-4-4a1,1,0,0,0-1.414,1.414L80.586,11H70a1,1,0,0,0,0,2H80.586l-2.293,2.293a1,1,0,1,0,1.414,1.414l4-4A1,1,0,0,0,83.923,12.382Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-logout.b82627b2.svg";
export { ForwardRef as ReactComponent };